<template>
  <div class="col-md-12">
    <h5>
      <span class="color-text"
        >{{
          mixedStep.items.length > 0 ? mixedStep.items.length : ""
        }}
        Product </span
      >Solutions
    </h5>
    <div class="row">
      <div
        v-for="(item, index) in mixedStep.items"
        :key="index"
        class="col-md-6 col-lg-4 col-xl-3"
      >
        <div class="solution-product">
          <div class="product-image">
            <a
              :href="culture + '/product/' + item.stockCode"
              @click="triggerGA(item.stockCode)"
            >
              <img
                class="solution-header-image"
                :src="
                  item.p_r_medias && item.p_r_medias.length
                    ? item.p_r_medias[0].mediaUrl
                    : ''
                "
                alt
                style="width: 100%"
              />
              <div
                v-if="item.newProduct == 1"
                class="__new-product"
              >
                <p>New</p>
              </div>
            </a>
            <div
              v-if="
                item.lngId == 7 &&
                clearanceStockcodes.includes(item.stockCode) &&
                item.onSaleProduct == 1
              "
              class="sale-product"
            >
              <p>{{ label_on_sale_product }}</p>
            </div>
          </div>
          <div class="product-details">

            <div class="product-details-title">
              <span v-if="getBar(item)" class="color-text"
                >{{ getBar(item) }} Bar</span
              >
              <div>
                <a
                  :href="culture + '/product/' + item.stockCode"
                  @click="triggerGA(item.stockCode)"
                >
                <span v-if="(culture === '/en-us' || culture === '/en-ca') && item.us_ca_title !== null && item.us_ca_title !== ''"
                  style="color: #000000; font-weight: 700; font-size: 18px"
                  >{{item.us_ca_title }}</span>
                <span v-else
                  style="color: #000000; font-weight: 700; font-size: 18px"
                  >{{ item.title }}</span>
                </a>
              </div>

              <div>
                <span>{{ item.stockCode }}</span>
              </div>
            </div>

            <div class="features">
                <hr />
                <div class="main-features"
                  v-for="(feature, index) in specificationFeatures(item)"
                  :key="index"
                >
                  <template>
                    <div class="features-list">
                      <template v-if="feature.field_type == 'Checkbox'">
                        <template v-for="(val,index) in feature.fmv_specification_value" >
                        <template v-if="val.id == feature.fmv_specification_value_id">
                        <img :src="val.icon_url" alt="" :key="index"/>
                        {{ val.value }}
                        </template>
                        </template>
                      </template>

                      <template
                        v-if="
                          feature.field_type == 'Input' &&
                          feature.input_value !== null &&
                          feature.input_value !== ''
                        "
                      >

                        <img :src="feature.icon_url" alt="" />
                        {{ feature.input_value }}
                      </template>
                    </div>
                  </template>
                  <template
                    v-if="hasSpecificationFeatures(item)"
                  >
                    <i :class="'icon icon-' + feature.value.toLowerCase()"></i>
                    {{ feature.name }}
                  </template>
                </div>

                <div class="clearfix"></div>
                <!-- <hr /> -->
              </div>

            <div class="product-cta-section">
              <hr />
              <div class="pricing">
                <div
                  v-if="
                    item.lngId == 7 &&
                    clearanceStockcodes.includes(item.stockCode) &&
                    item.onSaleProduct == 1
                  "
                >
                  <span style="font-family: trim-medium">Total</span>
                  <br />
                  <span class="initialPrice"
                    >RRP ${{ formatNumber(item.pricelevel1) }}
                  </span>
                  <br />
                  <span class="salePrice">{{ item.productPrice }}</span>
                  <span style="color: #a3a3a3">
                    (RRP inc GST) {{ int_curr_symbol }}
                  </span>
                </div>

                <div v-else-if="hide_price_global_value === '0'">
                  <span style="font-family: trim-medium">Total</span>
                  <br />
                  {{ item.productPrice }}
                  <span style="color: #a3a3a3"
                    >{{ currency_suffix }} {{ int_curr_symbol }}</span
                  >
                </div>
              </div>
              <!-- 
            <br />
            <br /> -->
              <div class="button">
                <a
                  :href="culture + '/product/' + item.stockCode"
                  class="btn btn-hover btn-wishlist btn-orange-full"
                  @click="triggerGA(item.stockCode)"
                  >VIEW PRODUCT</a
                >
              </div>
              <compare-checkbox
                style="bottom: 0px; background: transparent"
                :stockcode="item.stockCode"
                :producttitle="item.title"
                compare="Compare"
              >
              </compare-checkbox>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import minMaxPricing from "../../mixins/min-max-pricing.js";

export default {
  name: "solution-products",
  props: {
    mixedStep: Object,
    currency_suffix: String,
    int_curr_symbol: String,
    label_complete_kit: {
      type: String,
      default: "Complete Kit",
    },
    label_whats_included: {
      type: String,
      default: "What's Included",
    },
    label_qty: {
      type: String,
      default: "Qty",
    },
    label_view: {
      type: String,
      default: "View",
    },
    label_solution: {
      type: String,
      default: "Solution",
    },
    label_products: {
      type: String,
      default: "Products",
    },
    label_Bar: {
      type: String,
      default: "Bar",
    },
    label_Bars: {
      type: String,
      default: "Bars",
    },
    label_mount_style: {
      type: String,
      default: "Mount Style",
    },
    label_on_sale_product: {
      type: String,
      default: "SALE",
    },
    hide_price_global_value: {
        type: String,
        default: "0"
    },
  },
  mixins: [minMaxPricing],
  data() {
    return {
      culture: window.culture ? "/" + window.culture : "",
      userType: "B2C",
      hasProductSpecificSpecifications: "0",
      clearanceStockcodes: [
        "LC2112",
        "GU2112",
        "AT2112VA",
        "AT2112RB",
        "45111B",
        "45108B",
        "41103",
        "RVP26",
        "RVPT527",
        "43250",
        "43251",
        "RTD25L",
        "RBCA010",
        "RF1",
        "RTD35L",
        "43119B",
        "43120B",
        "RTS527",
        "RLKVFH",
        "RTS502",
        "RTS551",
      ],
      groupedfeatures: [],
    };
  },
  mounted() {
    this.filteredItems();
    this.isB2bUser();
  },
  methods: {
    filteredItems() {
      if (!this.mixedStep.items || !Array.isArray(this.mixedStep.items)) {
      return [];
      }
    const uniqueItemsMap = new Map();
    const filteredItems = [];

    this.mixedStep.items.forEach((item) => {
      const productId = item.productId;
      if (!uniqueItemsMap.has(productId)) {
        uniqueItemsMap.set(productId, item);
        filteredItems.push(item);
      }
    });

    this.mixedStep.items = filteredItems;

  },
    isB2bUser() {
      this.userType = this.$store.getters["auth/userType"];
    },
    triggerGA(stockCode) {
      ga("send", "event", "Fit My Vehicle", "Solutions", stockCode);
      gtag("event", "fit_my_vehicle_solutions", {
        category: "Fit My Vehicle",
        action: "Solutions",
        value: stockCode,
      });
    },
    selectProduct(categoryId) {
      this.$emit("selectProduct", categoryId);
    },
    hasSpecificationFeatures(product) {
      let hasSpecificationFeatures = false;

      this.specificationFeatures(product).forEach((feature, index) => {
        if (feature && feature.value && typeof feature.value === "string" && feature.value.toLowerCase() === "yes") {
          hasSpecificationFeatures = true;
        }
      });

      return hasSpecificationFeatures;
    },
    specificationFeatures(product) {
    var features = [];

    var parsedObj = [];
    if(typeof product.fmv_product_specification === 'object' && product.fmv_product_specification !== null){
        var parsedObj = JSON.parse(
          JSON.stringify(product.fmv_product_specification)
        );


      let flattenedData = parsedObj
        .map((item) => {
          if (item.field_type === "Input" && item.input_value === null){
            return null;
          }
          if (
            item.fmv_specification_title.length === 0 &&
            item.field_type !== "Input"
          ){
            return null;
          }
          let { fmv_specification_title, fmv_specification_value, ...rest } =
            item;
          return {
            ...rest,
            ...fmv_specification_title[0],
          };
        })
        .filter((item) => item !== null);
      if (flattenedData.length > 0) {
        this.hasProductSpecificSpecifications = 1;
        return flattenedData;
      }
    }

        const uniquePropertyIds = new Set();
        this.hasProductSpecificSpecifications = 0;
    for (let i = 0; i < product.product_specification_properties.length; i++) {
      var specProperty = product.product_specification_properties[i];
      const propertyId = specProperty.productSpecificationPropertyId;

      if (!uniquePropertyIds.has(propertyId) && specProperty.specification_property_master_data) {
        uniquePropertyIds.add(propertyId);
        const featuresList = specProperty.specification_property_master_data.features;
        features.push(...featuresList.filter(item => ["Yes", "No"].includes(item.value)));
      }
    }

    return features;
    },
    getBar(product) {
      // hide the bar label for pioneer products
      if (product.title.toLowerCase().indexOf("pioneer") > -1) {
        return null;
      }

      if (
        product.SpecificationProperties &&
        product.SpecificationProperties["# Of Bars Included"] &&
        product.SpecificationProperties["# Of Bars Included"][
          "# Of Bars Included"
        ]
      )
        return product.SpecificationProperties["# Of Bars Included"][
          "# Of Bars Included"
        ];
      else return null;
    },
    formatNumber(num) {
      return parseFloat(num).toFixed(2);
    },
  },
};
</script>

<style lang="scss" scoped>
.solution-product {
  padding: 0;
  background-color: #f8f8f8;

  @media only screen and (max-width: 767px) {
    height: auto !important;
  }

  .button {
    bottom: 15px;
    left: 0;
    right: 0;
    // padding: 0 15px;
    text-align: center;
  }

  hr {
    margin: 20px 0;
  }

  .product-image {
    .solution-header-image{
      @media screen and (min-width: 768px) {
        max-height: 135px;
        object-fit: cover;
      }
    }
    .sale-product {
      position: absolute;
      top: -1px;
      right: -1px;
      height: 100px;
      width: 82px;
      z-index: 1;

      &::before {
        content: "";
        display: block;
        position: absolute;
        z-index: 0;
        top: 0;
        right: 0;
        width: 0;
        height: 0;
        border: 40px solid transparent;
        border-top-color: #e74c3c;
        border-right-color: #e74c3c;
      }

      p {
        font-size: 0.8rem;
        -webkit-transform-origin: 21px 36px;
        transform-origin: 22px 22px;
        -webkit-transform: rotate(45deg);
        transform: rotate(45deg);
        color: #fff;
        text-transform: uppercase;
        position: relative;
        z-index: 1;
        width: 100px;
        text-align: center;
      }
    }
  }
}
.product-details {
  padding: 5px 25px 25px 25px;
  display: flex;
  flex-direction: column;

  .product-details-title{
    min-height: 78px;
  }

  .features {
    min-height: 182px;
    .main-features{
      padding-right: 1px;
      margin-top: 5px;
      i{
        vertical-align: middle;
      }
    .features-list {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 5px;
      font-size: 1rem;
      font-weight: 550;
      img {
        max-width: 24px;
      }
    }
    }
  }
  .pricing {
    .initialPrice {
      text-decoration: line-through;
    }
    .salePrice {
      color: red;
    }
  }
}
h5 {
  font-size: 22px;
  line-height: 26px;
}
.color-text {
  color: #005cb9;
  font-family: "trim-medium";
}
.product-image {
  border-bottom: 1px solid #b3b3b3;
}

.btn-orange-full,
.btn-green-full {
  padding: 5px 0;
}

.__new-product {
  position: absolute;
  top: 0px;
  right: -1px;
  height: 100px;
  width: 100px;
  z-index: 1;

  &::before {
    content: "";
    display: block;
    position: absolute;
    z-index: 0;
    top: 0;
    right: 0;
    width: 0;
    height: 0;
    border: 39px solid transparent;
    border-top-color: #005cb9;
    border-right-color: #005cb9;

    @media screen and (max-width: 500px) {
      border: 43px solid transparent;
      border-top-color: #005cb9;
      border-right-color: #005cb9;
    }
  }
  p {
    -webkit-transform-origin: 45px 50px;
    transform-origin: 45px 50px;
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
    color: #fff;
    text-transform: uppercase;
    font-family: "trim-medium";
    position: relative;
    z-index: 1;
    width: 100px;
    text-align: center;

    @media screen and (max-width: 500px) {
      padding-left: 0 !important;
    }
  }
}
</style>
